import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { LoginService } from '../login.service';
import { UserService } from '../../data/user.service';

@Injectable()
export class MustBeAdminGuardService implements CanActivate {

  constructor(
    private loginService: LoginService,
    private userService: UserService,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    return new Promise<boolean>((resolve, reject) => {
      this.userService.isAdmin//.requestIsAdmin()
        .subscribe((isAdmin) => {
          resolve(isAdmin);
        });
    });
  }

  //canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
  //  return new Promise<boolean>((resolve, reject) => {
  //    this.loginService.checkIsAdmin().then(response => {
  //      if (response !== true) {
  //        //this.router.navigate(['/error', 'unauthorized']);//Todo V
  //        this.router.navigate(['/', 'unauthorized']);
  //      }
  //
  //      resolve(response);
  //    });
  //  });
  //}
}
